import ToggleLightDarkMode from "../Utils/ToggleLightDarkMode";
import Footer from "./Footer";
import Header from "./Header";
import styles from "./Layout.module.css";

export default function Layout ({children}) {


    return (
        <div className={styles.layout}>
            <Header />
            <div className={styles.mainContent}>
                {children}
            </div>
            <Footer />
        </div>

    );
}